import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-10/task-01";

const task: Slide = {
  title: "Drag the correct equations to the correct equation group (Euler, mass conversation, state), knowing that:",
  description: "Drag and drop equations.",
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colSpan: {
        "1:0": 2,
      },
      rowsSize: [1, 4],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                            <mover>
                              <mi>v</mi>
                              <mo stretchy="false">→</mo>
                            </mover>
                            <mo>=</mo>
                            <msub>
                              <mover>
                                <mi>v</mi>
                                <mo stretchy="false">→</mo>
                              </mover>
                              <mrow>
                                <mi>a</mi>
                                <mi>c</mi>
                              </mrow>
                            </msub>
                            <mo>+</mo>
                            <msub>
                              <mover>
                                <mi>U</mi>
                                <mo stretchy="false">→</mo>
                              </mover>
                              <mn>0</mn>
                            </msub>
                            <mspace width="0.1667em"></mspace>
                            <mo separator="true">,</mo>
                        </math><br>
                        <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>

                            <mi>ρ</mi>
                            <mo>=</mo>
                            <msub>
                              <mi>ρ</mi>
                              <mn>0</mn>
                            </msub>
                            <mo>+</mo>
                            <msup>
                              <mi>ρ</mi>
                              <mo lspace="0em" rspace="0em" class="tml-prime">′</mo>
                            </msup>
                            <mtext> with </mtext>
                            <msup>
                              <mi>ρ</mi>
                              <mo lspace="0em" rspace="0em" class="tml-prime">′</mo>
                            </msup>
                            <mo>≪</mo>
                            <msub>
                              <mi>ρ</mi>
                              <mn>0</mn>
                            </msub>
                            <mspace width="0.1667em"></mspace>
                            <mo separator="true">,</mo>
                            </math><br>
                            <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>

                            <mi>P</mi>
                            <mo>=</mo>
                            <msub>
                              <mi>P</mi>
                              <mrow>
                                <mi>a</mi>
                                <mi>t</mi>
                                <mi>m</mi>
                              </mrow>
                            </msub>
                            <mo>+</mo>
                            <mi>p</mi>
                            <mtext> with </mtext>
                            <mi>p</mi>
                            <mo>≪</mo>
                            <msub>
                              <mi>P</mi>
                              <mrow>
                                <mi>a</mi>
                                <mi>t</mi>
                                <mi>m</mi>
                              </mrow>
                            </msub>
                            <mspace width="0.1667em"></mspace>
                            <mi>.</mi>

                  </mrow>
                </math>`,
                  formatter: "html",
                  scrollbars: false,
                },
              },
              styles: {
                justifyContent: "flex-end",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<math xmlns=http://www.w3.org/1998/Math/MathML>
                  <mover>
                    <mi mathvariant="normal">∇</mi>
                    <mo stretchy="false">→</mo>
                  </mover>
                  <mo form="prefix" stretchy="false">(</mo>
                  <mo>.</mo>
                  <mo>.</mo>
                  <mo>.</mo>
                  <mo form="postfix" stretchy="false">)</mo>
                  <mo>≡</mo>
                  <mover>
                    <mi mathvariant="normal">grad</mi>
                    <mo>→</mo>
                  </mover>
                  <mo form="prefix" stretchy="false">(</mo>
                  <mo>.</mo>
                  <mo>.</mo>
                  <mo>.</mo>
                  <mo form="postfix" stretchy="false">)</mo>
                  <mspace width="0.1667em"></mspace>
                  <mtext>and</mtext>
                  <mspace width="0.1667em"></mspace>
                  <mi mathvariant="normal">∇</mi>
                  <mo>⋅</mo>
                  <mo form="prefix" stretchy="false">(</mo>
                  <mo>.</mo>
                  <mo>.</mo>
                  <mo>.</mo>
                  <mo form="postfix" stretchy="false">)</mo>
                  <mo>≡</mo>
                  <mspace width="0.1667em"></mspace>
                  <mtext>div</mtext>
                  <mo form="prefix" stretchy="false">(</mo>
                  <mo>.</mo>
                  <mo>.</mo>
                  <mo>.</mo>
                  <mo form="postfix" stretchy="false">)</mo>
                </math>`,
                  formatter: "html",
                  scrollbars: false,
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
